import { useEffect, useState } from 'react'

import { t } from 'commons/libs/i18n'
import { Alert, Checkbox, Modal } from 'components'

import * as S from './styles'

export interface ReprocessModalProps {
  open: boolean
  setOpen: (isOpen: boolean) => void
  onConfirm?: () => void | Promise<void>
  loading?: boolean
  errorMessage?: string
}

export const ReprocessModal = ({
  open,
  setOpen,
  onConfirm,
  loading = false,
  errorMessage,
}: ReprocessModalProps) => {
  const [confirmed, setConfirmed] = useState(false)

  useEffect(() => {
    if (!open) setConfirmed(false)
  }, [open])

  const handleClose = () => {
    setConfirmed(false)
    setOpen(false)
  }

  const handleConfirm = async () => {
    await onConfirm?.()
  }

  return (
    <Modal
      alignContent="flex-start"
      buttonAction={handleConfirm}
      buttonDisabled={!confirmed}
      buttonText={t('screens.edi.reprocessModal.confirmButton')}
      buttonVariant="primary"
      closeAction={handleClose}
      loading={loading}
      modalWidth={640}
      open={open}
      returnAction={handleClose}
      returnIcon={false}
      returnText={t('buttons.back')}
      setOpen={setOpen}
      showReturn
      title={t('screens.edi.reprocessModal.title')}
      titleIcon="report"
    >
      <S.Content>
        <S.Description>{t('screens.edi.reprocessModal.description')}</S.Description>

        {!!errorMessage && <Alert fullWidth kind="error" title={errorMessage} />}

        <Checkbox
          bold
          checked={confirmed}
          label={t('screens.edi.reprocessModal.checkboxLabel')}
          onChange={(event) => setConfirmed(event.target.checked)}
          size="small"
        />
      </S.Content>
    </Modal>
  )
}
